import { toast } from 'sonner';

import { hasActiveCall, isActiveMuted, setMuted } from '../device/session-device';
import { useVoiceStore } from '../state/voice-ui.store';

/**
 * Flip mute on the live SDK leg. Surfaces a toast instead of silently
 * no-oping when no leg is connected — the old silent path made a dead mute
 * button indistinguishable from a working one.
 *
 * The button reads `activeCall.muted`, so it is synced from the SDK's own
 * state right here. Waiting for the SDK `mute` event left it stale: only
 * inbound Twilio legs are subscribed to that event, so on every outbound call
 * (and every held-call pick) the audio muted while the icon never moved, and
 * the next click silently unmuted. The event path still fires where wired —
 * it writes the same value, so the two never disagree.
 */
export function toggleActiveMute(): boolean {
    const ok = hasActiveCall() && setMuted(!isActiveMuted());
    if (!ok) {
        toast.error('Mute unavailable — call audio is not connected yet.');
        return false;
    }
    const { activeCall, patchActiveCall } = useVoiceStore.getState();
    if (activeCall) patchActiveCall(activeCall.callId, { muted: isActiveMuted() });
    return true;
}
